@if (card && card.data) {
<div class="flex flex-top">
    <payment-icon [method]="$any(card.data.type || '')"
                  [style.fontSize.px]="24"
                  class="m-r-5 m-r-2-s m-r-2-m inline-flex"></payment-icon>
    <div>
        <div [ngClass]="'logo-' + (card.data.type | lowercase)"></div>
        <p class="p1 col-11"> **** **** **** {{ card.data.last_four }}</p>
        <p class="p1 col-11"
           [class.col-2]="card.isExpired"> {{'Exp. %' | translate : card.data.expiry_date }}</p>
    </div>
</div>
}